<template>
  <div>
    <!-- 运行明细 -->
    <!-- 查询、 -->
    <div style="text-align:right">
      <el-form :inline="true" class="form">
        <el-form-item :label="$t('time.timeQuery')">
          <el-date-picker
            v-model="datetimerange"
            :size="size"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
            :placeholder="$t('vehicleInfo.selectusedate')"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            :picker-options="datePickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button 
            type="primary" 
            
            :size="size"
            style="margin-left:8px;"
            @click="handleQuery"
          >{{ $t("public.query")}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button 
            :size="size"
            type="primary"  plain 
            style="margin-left:10px"
            @click="download"
            :loading="downloading"
          >{{ $t("public.export")}}</el-button>
        </el-form-item>
      </el-form>
      
    </div>
    <!-- 表格 -->
    <div class="page_container_a">
      <el-table :data="dataList" border :size="size" :span-method="objectSpanMethod" v-loading="loading">
        <el-table-column :label="$t('runState.carNo')" align="center" min-width="85" prop="carNo" fixed="left"></el-table-column>
        <el-table-column :label="$t('runState.statDate')" align="center" min-width="110" prop="statDate" fixed="left"></el-table-column>
        <el-table-column :label="$t('runState.ACCOnTime')" align="center" min-width="110" prop="ACCOnTime" fixed="left"></el-table-column>
        <el-table-column :label="$t('runState.BeginTime')" align="center" min-width="110" prop="BeginTime"></el-table-column>
        <el-table-column :label="$t('runState.EndTime')" align="center" min-width="110" prop="EndTime"></el-table-column>
        <el-table-column :label="$t('runState.ACCOffTime')" align="center" min-width="110" prop="ACCOffTime"></el-table-column>
        <el-table-column :label="$t('runState.runDuration')" align="center" min-width="120" prop="runDuration">
          <template slot-scope="scope">{{fixed2(scope.row.runDuration)}}</template>
        </el-table-column>
        <el-table-column :label="$t('runState.driveDuration')" align="center" min-width="120" prop="driveDuration">
          <template slot-scope="scope">{{fixed2(scope.row.driveDuration)}}</template>
        </el-table-column>
        <el-table-column :label="$t('runState.idleDuration')" align="center" min-width="120" prop="idleDuration">
          <template slot-scope="scope">{{fixed2(scope.row.idleDuration)}}</template>
        </el-table-column>
        <el-table-column :label="$t('runState.airDuration')" align="center" min-width="150" prop="airDuration">
          <template slot-scope="scope">{{fixed2(scope.row.airDuration)}}</template>
        </el-table-column>
        <el-table-column :label="$t('runState.heaterDuration')" align="center" min-width="160" prop="heaterDuretion">
          <template slot-scope="scope">{{fixed2(scope.row.heaterDuretion)}}</template>
        </el-table-column>
        <el-table-column :label="$t('runState.minSpeed')" align="center" min-width="150" prop="minSpeed"></el-table-column>
        <el-table-column :label="$t('runState.maxSpeed')" align="center" min-width="150" prop="maxSpeed"></el-table-column>
        <el-table-column :label="$t('runState.avgSpeed')" align="center" min-width="150" prop="avgSpeed"></el-table-column>
        <el-table-column :label="$t('runState.mileage')" align="center" min-width="120" prop="mileage"></el-table-column>
        <el-table-column :label="$t('runState.oilConsume')" align="center" min-width="110" prop="oilConsume" v-if="hasOil"></el-table-column>
        <el-table-column :label="$t('runState.perOilConsume')" align="center" min-width="110" prop="perOilConsume" v-if="hasOil"></el-table-column>
        <el-table-column :label="$t('runState.elecConsume')" align="center" min-width="110" prop="elecConsume" v-if="hasPower"></el-table-column>
        <el-table-column :label="$t('runState.perElecConsume')" align="center" min-width="110" prop="perElecConsume" v-if="hasPower"></el-table-column>
        <el-table-column :label="$t('statistics.耗氢量')+'(kg)'" align="center" min-width="130" prop="HConsume" v-if="hasH"></el-table-column>
        <el-table-column :label="$t('statistics.百公里耗氢')" align="center" min-width="150" prop="perHConsume" v-if="hasH"></el-table-column>
        <el-table-column :label="$t('statistics.气耗')+'('+gasUnit+')'" align="center" min-width="130" prop="gasConsume" v-if="hasGas"></el-table-column>
        <el-table-column :label="$t('statistics.百公里耗气')+'('+gasUnit+')'" align="center" min-width="150" prop="perGasConsume" v-if="hasGas"></el-table-column>
      </el-table>
    </div>
    <div style="text-align: right ;margin-top:8px" class="pagination" v-show="total>0" >  <!--  -->
      <kl-pagination
        :total="total"
        :currentPage="currentPage"
        @current-change="currentchange"
        @size-change="sizeChange"
      ></kl-pagination>
      </div>
  </div>
</template>
<script>
import language from '@/utils/getLanguageId'
import { mapState } from "vuex";
export default {
  props:{
    size:{
      type: String,
    },
    isClicked:{
      type: Boolean,
      default:false,
    }
  },
  components:{},
  data(){
    return{
      datetimerange:[],
      downloading:false,
      vehicles:'',
      pageSize:10,
      currentPage:1,
      total:0,
      loading:false,
      needMergeArr: ["carNo", "statDate"], 
      rowMergeArrs: [],
      dataList:[],
    
      datePickerOptions: {
        disabledDate: (time) => {
          const now = new Date();
          const yesterday = new Date(now);
          yesterday.setDate(now.getDate() - 1);
          yesterday.setHours(23, 59, 59, 0); 

          let myyesterday=new Date(yesterday).getTime();
          return time.getTime() > myyesterday
                
        },
      },
      LanguageId:1,
      hasPower: false,
      hasOil: false,
      hasGas: false,
      hasH: false,
    }
  },
  computed:{
    ...mapState({
      operator: (state) => state.user.operator,
      selectedVehicles: state => state.app.vehicles.selectedVehicles,
    }),
    gasUnit(){
      if(this.$store.getters.gasUnit == "m3") return "m³";
      return this.$store.getters.gasUnit;
    },
    // 能源类型清单
    energyTypes() {
        return this.$store.getters.energyTypes;
    },
  },
  watch:{
  },
  methods:{
    getSelectedVehicles(){
      this.vehicles = "";
      for(let k = 0; k < this.selectedVehicles.length; k++){
        if(this.selectedVehicles[k].treeLevel == 5){
          this.vehicles = this.vehicles + this.selectedVehicles[k].nodeValue + ",";
        }
      }
      return this.vehicles.substring(0,this.vehicles.length-1);
    },
    fixed2(val){
      if(val == 0 || val == null || val == undefined || val == ""){
        return 0;
      }
      return val.toFixed(2)
    },
    sizeChange(val){
      this.pageSize = val;
      this.currentPage = 1;
      this.getList();
    },
    currentchange(val) {
      this.currentPage = val;
      this.getList();
    },
    getList(){
      this.loading = true;
      let beginTime,endTime;
      beginTime = this.datetimerange[0].split(" ")[1];
      endTime = this.datetimerange[1].split(" ")[1];
      this.$api.runStateDetailInfo({
        beginDate: this.datetimerange[0].split(" ")[0],
        endDate: this.datetimerange[1].split(" ")[0],
        beginTime: beginTime,
        endTime: endTime,
        OperatorID: this.operator.OperatorId + "",//"3574",// this.operator.OperatorId + "",
        vehicles: this.vehicles,
        PageNo: this.currentPage,
        PageSize: this.pageSize,
        IsExport: 0, // 0是查询 1是下载
        Language: this.LanguageId,
        Unit: this.gasUnit == 'm³' ? 'm3' : this.gasUnit,
      })
      .then((res)=>{
        if(res && res.code == 200){
          this.dataList = res.data;
          this.total = res.count;
          this.loading = false;
        }
      })
      .catch((e)=>{
        this.loading = false;
        this.dataList = [];
        this.total = 0;
      })
    },
    handleQuery(){
      this.vehicles = this.getSelectedVehicles();
      if(this.datetimerange == "" || this.datetimerange == null || this.datetimerange == undefined || this.datetimerange.length < 2){
        this.$message({
          message: this.$t("runState.select_search_date"),//'请选择查询时间',
          type: 'warning'
        });
        return ;
      }
      this.currentPage = 1;
      this.getList();
    },
    download(){
      this.vehicles = this.getSelectedVehicles();
      if(this.datetimerange == "" || this.datetimerange == null || this.datetimerange == undefined || this.datetimerange.length < 2){
        this.$message({
          message: this.$t("runState.select_search_date"),//'请选择查询时间',
          type: 'warning'
        });
        return ;
      }
      var that = this;
      that.downloading = true;
      let beginTime,endTime;
      beginTime = this.datetimerange[0].split(" ")[1];
      endTime = this.datetimerange[1].split(" ")[1];
      this.$api.
        downRunStateDetailInfo({
          beginDate: this.datetimerange[0].split(" ")[0],
          endDate: this.datetimerange[1].split(" ")[0],
          beginTime: beginTime,
          endTime: endTime,
          OperatorID: this.operator.OperatorId + "",
          vehicles: this.vehicles,
          IsExport: 1, // 0是查询 1是下载
          Language: this.LanguageId,
          Unit: this.gasUnit == 'm³' ? 'm3' : this.gasUnit,
        })
        .then((res) => {
          let blob = new Blob([res], {
            type: "application/vnd.ms-excel;charset=utf-8",
          }); // 重点代码
          let a = document.createElement("a");
          a.href = window.URL.createObjectURL(blob);
          a.setAttribute(
            "download",
            that.$t("runState.operDeal")+that.$t("public.download") + `_${that.timestampToTime(new Date().getTime())}.xlsx`
          ); // 表名，自定义
          a.click(); // 执行下载
          window.URL.revokeObjectURL(blob); // 释放ur
          that.downloading = false;
        })
        .catch((error) => {
          console.error("下载失败", error);
          that.downloading = false;
        });
    },
    //时间戳转换为日期格式
    timestampToTime(timestamp) {
      var date = new Date(timestamp); //时间数为10位篇*1000，时间数为13位的话不需乘1000
      var Y = date.getFullYear();
      var M =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var D = date.getDate();
      var h = date.getHours();
      var m = date.getMinutes();
      var s = date.getSeconds();
      return Y + M + D + h + m + s;
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if(j == "runDuration"){
          return this.fixed2(v[j]);
        }else if(j == "driveDuration"){
          return this.fixed2(v[j]);
        }else if(j == "idleDuration"){
          return this.fixed2(v[j]);
        }else if(j == "airDuration"){
          return this.fixed2(v[j]);
        }else if(j == "heaterDuretion"){
          return this.fixed2(v[j]);
        }else {
          return v[j];
        }
      }))
    },
    
    objectSpanMethod({ row, column, rowIndex, columnIndex}) {

      // 获取表格数据
      const data = this.dataList;
      // 合并 carNo 列
      if (columnIndex === 0) {
        if (rowIndex > 0 && row.carNo === data[rowIndex - 1].carNo) {
          return { rowspan: 0, colspan: 0 };  // 合并当前和上一行的 carNo
        } else {
          let rowspan = 1;
          for (let i = rowIndex + 1; i < data.length; i++) {
            if (data[i].carNo === row.carNo) {
              rowspan++;
            } else {
              break;
            }
          }
          return {
            rowspan: rowspan, // 合并的行数
            colspan: 1 // carNo 列合并
          };
        }
      }

      // 合并 statDate 列
      if (columnIndex === 1) {
        if (rowIndex > 0 && row.statDate === data[rowIndex - 1].statDate && row.carNo === data[rowIndex - 1].carNo) {
          return { rowspan: 0, colspan: 0 };  // 合并当前和上一行的 statDate
        } else {
          let rowspan = 1;
          for (let i = rowIndex + 1; i < data.length; i++) {
            if (data[i].carNo === row.carNo && data[i].statDate === row.statDate) {
              rowspan++;
            } else {
              break;
            }
          }
          return {
            rowspan: rowspan, // 合并的行数
            colspan: 1 // statDate 列合并
          };
        }
      }

      // 其他列的处理
      return {
        rowspan: 1,
        colspan: 1
      };
    },
  },
  created(){
    
    },
  mounted(){
    // this.getList();
    this.hasPower = this.energyTypes.includes("3")||this.energyTypes.includes("4")||this.energyTypes.includes("5")||this.energyTypes.includes("6");
    this.hasOil = this.energyTypes.includes("1")||this.energyTypes.includes("3");
    this.hasGas = this.energyTypes.includes("2")||this.energyTypes.includes("4");
    this.hasH = this.energyTypes.includes("6");
    this.LanguageId = language(this.$store.getters.locale);
    
    const now = new Date();
    const yesterdayBegin = new Date(now);
    const yesterdayEnd = new Date(now);
    yesterdayBegin.setDate(now.getDate() - 1);
    yesterdayBegin.setHours(0, 0, 0, 0); 
    yesterdayEnd.setDate(now.getDate() - 1);
    yesterdayEnd.setHours(23, 59, 59, 0); 

    let begin=new Date(yesterdayBegin);
    let end=new Date(yesterdayEnd);
    this.datetimerange = [ this.moment(begin).format("YYYY-MM-DD HH:mm:ss") ,this.moment(end).format("YYYY-MM-DD HH:mm:ss")];
    this.handleQuery();
  }
}
</script>
<style lang="scss" scoped>
.form  {
  ::v-deep .el-form-item {
      margin-bottom: 0px !important;
  }
}
.page_container_a {
    margin-top: 10px;

    ::v-deep .el-table tr {
        background: rgb(244, 248, 255);
    }

    ::v-deep .el-table {
        background: rgb(244, 248, 255);
    }

    ::v-deep .el-table td {
        background: rgb(244, 248, 255);
    }
} 
</style>